import React, { useState } from "react";
import SectionShell from "../layout/SectionShell";
import { projectFilters, projectsData } from "../../mock/portfolioData";
import { Badge } from "../ui/badge";
import { ChevronDown, ChevronUp } from "lucide-react";

export function ProjectsSection() {
  const [activeFilter, setActiveFilter] = useState("all");
  const [expandedId, setExpandedId] = useState(projectsData[0]?.id ?? null);

  const filteredProjects =
    activeFilter === "all"
      ? projectsData
      : projectsData.filter((project) => project.category === activeFilter);

  return (
    <SectionShell id="projects" title="Projects" kicker="Selected work">
      <div className="mb-6 flex flex-wrap gap-2">
        {projectFilters.map((filter) => (
          <button
            key={filter.id}
            type="button"
            onClick={() => setActiveFilter(filter.id)}
            className={`rounded-full border px-3 py-1 text-xs font-mono font-medium tracking-[0.08em] transition-colors ${
              activeFilter === filter.id
                ? "border-pink-400 bg-slate-950 text-pink-100 shadow-[0_0_18px_rgba(244,114,182,0.45)]"
                : "border-slate-700 bg-slate-900 text-slate-300 hover:border-pink-400/70 hover:text-pink-100"
            }`}
          >
            {filter.label}
          </button>
        ))}
      </div>

      <div className="space-y-4">
        {filteredProjects.map((project) => {
          const isExpanded = expandedId === project.id;
          return (
            <article
              key={project.id}
              className="rounded-2xl border border-slate-800 bg-slate-900/70 p-4 shadow-[0_0_22px_rgba(15,23,42,0.9)] transition-colors hover:border-cyan-400/70"
            >
              <button
                type="button"
                onClick={() =>
                  setExpandedId(isExpanded ? null : project.id)
                }
                className="flex w-full items-start justify-between gap-3 text-left"
              >
                <div>
                  <h3 className="text-sm font-semibold text-slate-50">
                    {project.title}
                  </h3>
                  <p className="mt-1 font-mono text-[11px] font-medium uppercase tracking-[0.18em] text-cyan-300">
                    {project.role}
                  </p>
                  <p className="mt-2 text-xs text-slate-300">
                    {project.summary}
                  </p>
                  <div className="mt-3 flex flex-wrap gap-1.5">
                    {project.techStack.map((tech) => (
                      <Badge
                        key={tech}
                        variant="outline"
                        className="border-slate-600 bg-slate-950 text-[10px] font-mono font-medium tracking-[0.08em] text-slate-100"
                      >
                        {tech}
                      </Badge>
                    ))}
                  </div>
                </div>
                <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full border border-slate-700 bg-slate-900 text-cyan-300">
                  {isExpanded ? (
                    <ChevronUp className="h-3 w-3" />
                  ) : (
                    <ChevronDown className="h-3 w-3" />
                  )}
                </span>
              </button>

              {isExpanded && (
                <div className="mt-4 border-t border-slate-800 pt-3 text-xs text-slate-300">
                  <p className="mb-2">{project.details}</p>
                  <ul className="list-disc space-y-1 pl-4">
                    {project.outcomes.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              )}
            </article>
          );
        })}
      </div>
    </SectionShell>
  );
}

export default ProjectsSection;
